import React, { Component } from "react";
import Footer from "./Footer";
import { ROOT, apiROOT } from "../config/config";
import store from "../store";

class ColumnThree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnThreePost: []
    };
  }

  componentDidMount() {
    fetch(`${apiROOT}blog/getColumnThreePost`)
      .then(res => res.json())
      .then(data => {
        this.setState({
          columnThreePost: data.columnThreePost
        });
      });
  }

  render() {
    return (
      <div className="columnThree">
        <p className="c3-post-header">
          Recent topics
          {parseInt(store.getState().columnOne.details.user_id) > 0
            ? " Based On Your Reads"
            : ""}{" "}
        </p>
        {this.state.columnThreePost.map(p => (
          <a href={`${ROOT}post/${p.slug}-${p.post_id}`} key={p.post_id}>
            <p
              className="c3-post-title"
              dangerouslySetInnerHTML={{
                __html: p.post_title
              }}
            ></p>
          </a>
        ))}
        <Footer />
      </div>
    );
  }
}

export default ColumnThree;
